import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import baseURL from './baseURl';

const Clients = () => {
  const [activeTab, setActiveTab] = useState('create');
  const [clientData, setClientData] = useState({
    name: '',
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [responseMessage, setResponseMessage] = useState('');

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setResponseMessage('');
    setSearchResults([]);
    setSearchQuery(''); // Clear search query when switching tabs
  };

  // Handle input change for create client form
  const handleChange = (e) => {
    setClientData({
      ...clientData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle client creation form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${baseURL}/api/clients/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(clientData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setResponseMessage(`Client registered successfully: ${data.name}`);
      setClientData({ name: '' }); // Reset only the name field
    } catch (error) {
      console.error(error);
      setResponseMessage(`Error: ${error.message}`);
    }
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    // Perform search if the query length is greater than 0
    if (query.length > 0) {
      handleSearch(query);
    } else {
      // Clear search results if query is empty
      setSearchResults([]);
      setResponseMessage('');
    }
  };

  // Function to fetch search results
  const handleSearch = async (query) => {
    try {
      const response = await fetch(`${baseURL}/api/clients/search?query=${query}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setSearchResults(data);
      if (data.length === 0) {
        setResponseMessage('No clients found');
      } else {
        setResponseMessage('');
      }
    } catch (error) {
      console.error(error);
      setResponseMessage(`Error: ${error.message}`);
    }
  };

  return (
    <div className="container mt-5">
      <div className="card">
        <div className="card-header">
          <ul className="nav nav-tabs card-header-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'create' ? 'active' : ''}`}
                onClick={() => handleTabChange('create')}
              >
                Create Client
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'search' ? 'active' : ''}`}
                onClick={() => handleTabChange('search')}
              >
                Search Clients
              </button>
            </li>
          </ul>
        </div>
        <div className="card-body">
          {activeTab === 'create' && (
            <div className="create-client">
              <h5 className="card-title">Create Client</h5>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={clientData.name}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary">Register Client</button>
              </form>
              {responseMessage && <div className="alert alert-info mt-3">{responseMessage}</div>}
            </div>
          )}

          {activeTab === 'search' && (
            <div className="search-client">
              <h5 className="card-title">Search Clients</h5>
              <div className="mb-3">
                <label className="form-label">Search by Name</label>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className="form-control"
                  required
                />
              </div>
              {responseMessage && <div className="alert alert-info mt-3">{responseMessage}</div>}
              {searchResults.length > 0 && (
                <ul className="list-group mt-3">
                  {searchResults.map((client) => (
                    <li key={client._id} className="list-group-item">
                      <strong>Name:</strong> {client.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Clients;
